class Newsletter {
  constructor (data) {
    this.id = data ? data.id : ''
    this.email = data ? data.email : ''
    this.subscribe_to = data ? data.subscribe_to : ''
    this.created_at = data ? data.created_at : ''
  }
}

export default Newsletter



// WEBPACK FOOTER //
// ./src/models/Newsletter.js